<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div class="ir-btn th-btn-normal" [permissions]="[['visible', 'inspection.offline.edit', inspection]]" [routerLink]="getEditRoute()">
        <span>{{ 'common.edit' | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.spo-train.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content">
        <td class="th-plugin-line--data" *ngFor="let message of messages">
          <span>{{ message }}</span>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <table class="ir-plugin-table" *ngIf="spoLockings?.length > 0">
      <tr class="th-plugin-line--header">
        <td colspan="3">
          <span>{{ 'plugins.spo-locking.os' | translate }}</span>
        </td>
        <td colspan="3">
          <span>{{ 'plugins.spo-locking.oos' | translate }}</span>
        </td>
      </tr>
      <tr class="th-plugin-line--subheader">
        <td>
          <span>N°</span>
        </td>
        <td>
          <span>{{ 'plugins.spo-locking.gap' | translate }}</span>
        </td>
        <td>
          <span>{{ 'plugins.spo-locking.os' | translate }}</span>
        </td>
        <td>
          <span></span>
        </td>
        <td>
          <span>{{ 'plugins.spo-locking.oos' | translate }}</span>
        </td>
        <td>
          <span>{{ 'plugins.spo-locking.gap' | translate }}</span>
        </td>
      </tr>
      <tr class="th-plugin-line--content" *ngFor="let item of spoLockings">
        <td>
          <span>{{ item.Id }}.</span>
        </td>
        <td class="important">
          <span class="important">{{ item.OsGap | number : '1.2-2' }}</span>
        </td>
        <td>
          <span>{{ item.Os }}</span>
        </td>
        <td>
          <span></span>
        </td>
        <td>
          <span>{{ item.Oos }}</span>
        </td>
        <td class="important">
          <span class="important">{{ item.OosGap | number : '1.2-2' }}</span>
        </td>
      </tr>
      <tr class="th-plugin-line--subheader">
        <td colspan="5">
          <span>{{ 'plugins.spo-locking.average' | translate }}</span>
        </td>
        <td>
          <span>{{ 'plugins.spo-locking.total-gap' | translate }}</span>
        </td>
      </tr>
      <tr class="th-plugin-line--subheader">
        <td colspan="2">
          <span>{{ 'plugins.spo-locking.gripper-bar' | translate }}</span>
        </td>
        <td class="important">
          <span class="important">{{ plugin.config.AverageOs | number : '1.2-2' }}</span>
        </td>
        <td></td>
        <td class="important">
          <span class="important">{{ plugin.config.AverageOos | number : '1.2-2' }}</span>
        </td>
        <td class="important">
          <span class="important">{{ plugin.config.Gap | number : '1.2-2' }}</span>
        </td>
      </tr>
    </table>
  </div>
</div>
